import { ref } from 'vue'
import { defineStore } from 'pinia'

type Options = {
    message?: string
}

export const useLoadingStore = defineStore('loading', () => {
    const opened = ref(false)
    const message = ref()

    function open(options?: Options) {
        message.value = 'Loading please wait...'

        if (options && options.message) {
            message.value = options.message
        }

        opened.value = true
    }

    function close() {
        opened.value = false
    }

    return { opened, message, open, close }
})
